var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-area",staticStyle:{"width":"100%","height":"100%","margin-left":"0px"},attrs:{"id":_vm.mapId,"type":_vm.mapType}})}
var staticRenderFns = []

export { render, staticRenderFns }